import { Stack } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';
import { FilterLabel } from './FilterLabel';

export interface FilterFieldProps extends PropsWithChildren {
  label?: string;
  htmlFor?: string;
  description?: string;
  action?: ReactNode;
  gap?: number;
}

export function FilterField({
  label,
  htmlFor,
  description,
  action,
  gap = 0.5,
  children,
}: FilterFieldProps) {
  return (
    <Stack gap={gap}>
      {label && (
        <FilterLabel htmlFor={htmlFor} description={description} action={action}>
          {label}
        </FilterLabel>
      )}
      {children}
    </Stack>
  );
}
